/* ══════════════════════════════════════
   MASTER ARTISANS — scroll-linked (desktop) +
   horizontal autoplay carousel (mobile ≤749px).
   Desktop: scroll drives stacked zoom reveal.
   Mobile: full-height slides in a row; track
   translates left so the next slide enters from
   the right (right-to-left flow).
   Reduced-motion: static stacked stack (all sizes).
══════════════════════════════════════ */
(function () {
    var MOBILE_MQ = "(max-width: 749px)";
    /** Time each slide stays before advancing (ms) */
    var MOBILE_SLIDE_MS = 4500;
  
    function init(root) {
      var section = root.closest(".master-artisans-section") || root;
  
      var slides = Array.prototype.slice.call(
        root.querySelectorAll("[data-slide]")
      );
      var total = slides.length;
      if (total < 1) return;
  
      var reduced =
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  
      var isMobile =
        window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  
      /* ── Tuning (desktop scroll) ── */
      var TINY_SCALE = 0.06;
      var FULL_SCALE = 1.0;
      var GROW = 0.72;
      var APPEAR = 0.28;
      var TAIL = 0.82;
  
      function ease(t) {
        t = Math.max(0, Math.min(1, t));
        return t * t * (3 - 2 * t);
      }
      function easeOutCubic(t) {
        t = Math.max(0, Math.min(1, t));
        return 1 - Math.pow(1 - t, 3);
      }
      function clamp(v, a, b) {
        return Math.max(a, Math.min(b, v));
      }
      function isTextSlide(slide) {
        return slide.getAttribute("data-slide-type") === "text";
      }
      function imageEl(slide) {
        return slide.querySelector(
          ".master-artisans-slider__img, .master-artisans-slider__placeholder"
        );
      }
      function textInnerEl(slide) {
        return slide.querySelector(".master-artisans-slider__text-inner");
      }
      function overlayEl(slide) {
        return slide.querySelector(".master-artisans-slider__overlay-title");
      }
  
      function render(progress) {
        slides.forEach(function (slide, i) {
          var d = progress - i;
  
          if (isTextSlide(slide)) {
            var ti = textInnerEl(slide);
            slide.style.opacity = 1;
            slide.style.zIndex = 1;
            slide.style.pointerEvents = "auto";
            if (ti) {
              ti.style.opacity = 1;
              ti.style.transform = "scale(1)";
              ti.style.transition = "none";
            }
            return;
          }
  
          var img = imageEl(slide);
          var ov = overlayEl(slide);
  
          var reached = d >= 0;
          var opacity = reached ? easeOutCubic(clamp(d / APPEAR, 0, 1)) : 0;
  
          slide.style.opacity = opacity;
          slide.style.zIndex = reached ? Math.round(i + 2) : 0;
          slide.style.pointerEvents = opacity > 0.5 ? "auto" : "none";
  
          var growing = ease(clamp(d / GROW, 0, 1));
          var scale = TINY_SCALE + (FULL_SCALE - TINY_SCALE) * growing;
  
          if (img) {
            img.style.transform = "scale(" + scale.toFixed(4) + ")";
            img.style.transition = "none";
          }
  
          if (ov) {
            var ovProg = ease(clamp((d - GROW * 0.7) / (GROW * 0.4), 0, 1));
            ov.style.opacity = ovProg;
            var ox = 40 * (1 - ovProg);
            var oy = 14 * (1 - ovProg);
            ov.style.transform =
              "translate(" + ox.toFixed(2) + "px," + oy.toFixed(2) + "px)";
            ov.style.transition = "none";
          }
        });
      }
  
      function targetProgressFromScroll() {
        var rect = section.getBoundingClientRect();
        var stageH = root.offsetHeight;
        var scrollable = section.offsetHeight - stageH;
        if (scrollable <= 0) return 0;
        var scrolled = clamp(-rect.top, 0, scrollable);
        var p = scrolled / scrollable;
        var prog = (p / TAIL) * total;
        return Math.min(prog, total - 0.0001);
      }
  
      if (reduced) {
        slides.forEach(function (slide, i) {
          slide.style.opacity = 1;
          slide.style.zIndex = isTextSlide(slide) ? 1 : Math.round(i + 2);
          var img = imageEl(slide);
          if (img) img.style.transform = "scale(1)";
          var ti = textInnerEl(slide);
          if (ti) {
            ti.style.opacity = 1;
            ti.style.transform = "none";
          }
          var ov = overlayEl(slide);
          if (ov) {
            ov.style.opacity = 1;
            ov.style.transform = "none";
          }
        });
        var anyMedia = slides.some(function (s) {
          return !isTextSlide(s);
        });
        if (!anyMedia) {
          slides.forEach(function (s) {
            var ti = textInnerEl(s);
            if (ti) ti.style.opacity = 1;
          });
        }
        return;
      }
  
      /* ── Mobile: horizontal carousel (R→L: next from right) ── */
      if (isMobile) {
        section.classList.add("master-artisans-section--mobile-carousel");
        var track = root.querySelector("[data-track]");
        if (!track) return;
  
        var slideIndex = 0;
        var autoplayTimer = 0;
  
        slides.forEach(function (slide) {
          slide.style.opacity = "";
          slide.style.zIndex = "";
          slide.style.pointerEvents = "";
          var img = imageEl(slide);
          if (img) {
            img.style.transform = "";
            img.style.transition = "";
          }
          var ov = overlayEl(slide);
          if (ov) {
            ov.style.opacity = "";
            ov.style.transform = "";
            ov.style.transition = "";
          }
        });
  
        var MOBILE_MAX_VH = 0.75;

        function slideWidth() {
          return root.offsetWidth || 1;
        }

        function mobileSlideHeight(slide) {
          var w = slideWidth();
          var maxH = window.innerHeight * MOBILE_MAX_VH;

          if (isTextSlide(slide)) {
            var inner = textInnerEl(slide);
            var contentH = inner ? inner.offsetHeight + 96 : 0;
            return Math.min(Math.max(contentH, w * 0.55), maxH);
          }

          var img = imageEl(slide);
          if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
            var ratioH = w * (img.naturalHeight / img.naturalWidth);
            return Math.min(Math.max(ratioH, w * 0.45), maxH);
          }

          return Math.min(w * 0.75, maxH);
        }

        function syncMobileHeight(skipTransition) {
          var slide = slides[slideIndex];
          var h = mobileSlideHeight(slide);
          if (skipTransition) {
            root.style.transition = "none";
          }
          root.style.height = h + "px";
          if (skipTransition) {
            void root.offsetHeight;
            root.style.transition = "";
          }
        }

        function applyTransform(skipTransition) {
          var w = slideWidth();
          var x = -slideIndex * w;
          if (skipTransition) {
            track.style.transition = "none";
          }
          track.style.transform = "translate3d(" + x + "px, 0, 0)";
          syncMobileHeight(skipTransition);
          if (skipTransition) {
            void track.offsetHeight;
            track.style.transition = "";
          }
        }
  
        function nextSlide() {
          slideIndex = (slideIndex + 1) % total;
          applyTransform(false);
        }
  
        function startAutoplay() {
          stopAutoplay();
          if (total > 1) {
            autoplayTimer = window.setInterval(nextSlide, MOBILE_SLIDE_MS);
          }
        }
  
        function stopAutoplay() {
          if (autoplayTimer) {
            window.clearInterval(autoplayTimer);
            autoplayTimer = 0;
          }
        }
  
        function onResize() {
          applyTransform(true);
        }
  
        function onVisibility() {
          if (document.hidden) {
            stopAutoplay();
          } else {
            applyTransform(true);
            startAutoplay();
          }
        }
  
        slides.forEach(function (slide) {
          var img = imageEl(slide);
          if (!img) return;
          function onImgReady() {
            if (slides[slideIndex] === slide) {
              applyTransform(true);
            }
          }
          if (img.complete && img.naturalWidth > 0) {
            onImgReady();
          } else {
            img.addEventListener("load", onImgReady, { once: true });
          }
        });

        applyTransform(true);
        startAutoplay();
        window.addEventListener("resize", onResize, { passive: true });
        document.addEventListener("visibilitychange", onVisibility);
        return;
      }
  
      /* ── Desktop: scroll-linked smoothing ── */
      var desktopSmoothMin = 0.12;
      var desktopSmoothMax = 0.34;
      var current = targetProgressFromScroll();
      var target = current;
      var running = false;
  
      function loop() {
        var diff = target - current;
        var dist = Math.abs(diff);
        if (dist < 0.0004) {
          current = target;
          render(current);
          running = false;
          return;
        }
        var k =
          desktopSmoothMin +
          (desktopSmoothMax - desktopSmoothMin) * clamp(dist, 0, 1);
        current += diff * k;
        render(current);
        requestAnimationFrame(loop);
      }
  
      function kick() {
        target = targetProgressFromScroll();
        if (!running) {
          running = true;
          requestAnimationFrame(loop);
        }
      }
  
      window.addEventListener("scroll", kick, { passive: true });
      window.addEventListener("resize", kick, { passive: true });
      window.addEventListener("orientationchange", kick, { passive: true });
  
      render(current);
    }
  
    document
      .querySelectorAll("[data-master-artisans-slider]")
      .forEach(init);
  })();
  